"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLegacyLoginBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateLegacyLoginBody = (0, validation_1.properties)({
    email: (0, validation_1.text)(),
    code: (0, validation_1.text)(),
});
//# sourceMappingURL=LegacyLoginBody.js.map